//api url
//server or local
const currentEnvironment = "production";

//local computer
const APILOCAL = "http://localhost:5002";
const APIPRODUCTION = "https://api.mylifeclock.io";

// Dynamically assign API based on environment
const API = currentEnvironment === "local" ? APILOCAL : APIPRODUCTION;

export {API};


//digital ocean webserver
//export const API = "https://api.turbinerunnerapp.com";

//dont know what this is for
// export const API = "http://back.turbinerunner.com";

//dont think this is needed
//const api = "https://turbinerunnerapp.com:5002";

export const HEADERS = {
    "Accept": "application/json",
}